module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/sweatshirt/6-9b1903bbe6da148a3f0d638d4b63530c.jpg";